import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.529 6.029c0 1.17-.443 2.235-1.17 3.039h-.001l1.901 5.341L8 12.991l-5.259 1.418L4.64 9.066a4.53 4.53 0 1 1 7.89-3.037Zm-1.5 0C11.029 4.36 9.67 3 7.999 3 6.33 3 4.97 4.402 4.97 6.03a3.033 3.033 0 0 0 2.903 3.026h.252A3.004 3.004 0 0 0 11.03 6.03Zm-3.78 4.467a4.498 4.498 0 0 1-1.363-.46l-.774 2.18 2.137-.576v-1.144Zm1.5 0v1.143l2.137.576-.775-2.178a4.487 4.487 0 0 1-1.362.459ZM7.09 5.501l1.438-.381.381 1.437-1.437.381-.382-1.437Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as Award
};
